import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import TireTreadModel from './tire-tread-model';
import TireTreadModelDetail from './tire-tread-model-detail';
import TireTreadModelUpdate from './tire-tread-model-update';
import TireTreadModelDeleteDialog from './tire-tread-model-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={TireTreadModelUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={TireTreadModelUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={TireTreadModelDetail} />
      <ErrorBoundaryRoute path={match.url} component={TireTreadModel} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={TireTreadModelDeleteDialog} />
  </>
);

export default Routes;
